import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ArthaGateway from 'service/ArthaGateway';

export const FileUpload = ({ buttonName, folder, onFileUpload }) => {
    const [file, setFile] = useState<File | null>(null);

    useEffect(() => {
        if (!file) return;

        uploadFile();
    }, [file]);

    const uploadFile = async () => {
        try {
            const response = await ArthaGateway.uploadFile(file, folder);
            onFileUpload(response);
        } catch (err) {
            console.error('Upload error:', err);
        }
    };

    return (
        <div>
            <input
                type="file"
                onChange={e => {
                    const files = e.target.files;
                    setFile(files && files.length > 0 ? files[0] : null);
                }}
                accept="*"
                style={{ display: 'none' }}
            />
            <button type="button" className="btn btn-dark w-100 my-2" onClick={() => {
                setFile(null);
                const inputElem = document.querySelector('input[type="file"]');
                if (inputElem) {
                    (inputElem as HTMLInputElement).click();
                }
            }}>{buttonName}</button>
        </div>
    );
}
